export default function AideDomicileHero() {
  return (
    <section className="relative min-h-[680px] flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=caring%20professional%20caregiver%20in%20light%20uniform%20helping%20smiling%20elderly%20senior%20woman%20at%20home%20Geneva%20Switzerland%20warm%20cozy%20bright%20living%20room%20natural%20light%20flowers%20on%20table%20gentle%20kind%20supportive%20atmosphere%20home%20care%20service&width=1920&height=700&seq=aide-hero-v2-01&orientation=landscape"
          alt="Aide à domicile à Genève"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-900/85 via-stone-900/55 to-stone-900/20"></div>
      </div>

      <div className="relative z-10 w-full mx-auto max-w-7xl px-6 lg:px-8 py-28">
        <div className="max-w-2xl">
          {/* Badge univers */}
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-rose-500/20 border border-rose-400/40">
              <i className="ri-heart-line text-rose-400 text-sm"></i>
            </div>
            <span className="text-xs font-bold tracking-widest uppercase text-rose-400">Univers Services · HB Services</span>
          </div>

          <h1 className="text-5xl md:text-6xl font-bold tracking-tight text-white mb-6 leading-tight">
            Aide à domicile<br />
            <span className="text-rose-400">avec bienveillance</span>
          </h1>
          <p className="text-lg text-white/75 leading-relaxed mb-10 max-w-xl">
            Accompagnement humain et professionnel pour les personnes âgées ou dépendantes. Ménage, courses, présence et soutien pour maintenir l'autonomie à domicile.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a href="#contact-aide" className="inline-flex items-center justify-center gap-2 rounded-lg bg-rose-500 px-7 py-3.5 text-sm font-semibold text-white hover:bg-rose-600 transition-all whitespace-nowrap cursor-pointer">
              <i className="ri-heart-line"></i>
              Demander un accompagnement
            </a>
            <a href="#services-aide" className="inline-flex items-center justify-center gap-2 rounded-lg bg-white/10 backdrop-blur-sm px-7 py-3.5 text-sm font-semibold text-white border border-white/25 hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer">
              <i className="ri-eye-line"></i>
              Découvrir nos services
            </a>
          </div>

          {/* Stats */}
          <div className="mt-14 flex flex-wrap gap-8">
            {[
              { value: '200+', label: 'Familles accompagnées' },
              { value: '7j/7', label: 'Disponibilité' },
              { value: '100%', label: 'Personnel certifié' },
            ].map((stat, i) => (
              <div key={i}>
                <div className="text-2xl font-bold text-white">{stat.value}</div>
                <div className="text-xs text-white/50 mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Badges flottants */}
      <div className="absolute bottom-8 right-8 hidden lg:flex flex-col gap-3">
        {[
          { icon: 'ri-heart-line', text: 'Accompagnement humain' },
          { icon: 'ri-shield-check-line', text: 'Personnel certifié' },
          { icon: 'ri-time-line', text: 'Flexibilité 7j/7' },
        ].map((b, i) => (
          <div key={i} className="flex items-center gap-2.5 bg-white/10 backdrop-blur-md border border-white/20 rounded-lg px-4 py-2.5">
            <i className={`${b.icon} text-rose-400 text-sm`}></i>
            <span className="text-xs font-medium text-white">{b.text}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
